/* Slideshow */
function shuffle(slidediv) {

  count=$(slidediv).length;          
  if(count>1) {
    parent=$(slidediv).parent();	
    loop=count*count-1;
    if(loop>100) loop=100;
    while(loop>0) {
      pos=Math.floor(Math.random()*count);  
      if (loop%2 == 0)
        $(slidediv).eq(pos).detach().prependTo(parent);    
	  else        
        $(slidediv).eq(pos).detach().appendTo(parent);    
      loop--;
    }
  }
  $(slidediv).eq(0).addClass("is-selected").css("visibility", "visible"); 
  $(slidediv).eq(0).find("img").each(function() {
    $(this).removeClass("Image--lazyLoad");
    master=$(this).data("src").replace("{width}","1600");
    $(this).attr("src",master);
  });
}


/* Collection List */
function alternative(sectiondiv,setcount) {
  
  while(setcount>0) {   
    count=$(sectiondiv+" a[data-choice='set"+setcount+"']").length;
    if(count>1) {
      parent=$(sectiondiv+" a[data-choice='set"+setcount+"']").parent();	
      pos=Math.floor(Math.random()*count);
      mem=$(sectiondiv+" a[data-choice='set"+setcount+"']").eq(pos);
      $(sectiondiv+" a[data-choice='set"+setcount+"']").remove();          
      mem.appendTo(parent);    
    }
    setcount--;
  }  
  
}